import React, { Component } from 'react';
import styles from './styles.module.scss';
import { ThemeContext } from 'app-themes';

interface Props {
	title?: string;
}

export class UserProfileBox extends Component<Props> {
	static contextType = ThemeContext;

	render() {
		const { title, children } = this.props;

		return (
			<div className={styles.userCol}>
				<div className={styles.userBox}>
					{title && <h3 className={styles.userLabel}>{title}</h3>}
					{children}
				</div>
			</div>
		);
	}
}

export default UserProfileBox;
